// ProductHeader.js
import React from "react";
import { Box, DialogTitle } from "@mui/material";
import CustomTypography from "../../globalStyles/fonts";

const ProductHeader = ({ productId }) => {
  return (
    <Box display="flex" justifyContent="space-between">
      <DialogTitle
        id="form-dialog-title"
        style={{ fontFamily: "Poppins", fontWeight: 500, color: "var(--text-primary)" }}
      >
        <CustomTypography fontWeight={500} fontSize={20}>
          {`${productId === "create" ? "Create" : "Edit"} Product`}
        </CustomTypography>
      </DialogTitle>
    </Box>
  );
};

export default ProductHeader;
